<template>
  <div class="h-100">
    <v-dialog v-model="settingsDialog" max-width="290">
      <v-card flat>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Units</h3>
            <div>Set your prefered units of measurement for logging workouts, weight and more</div>
            <v-radio-group v-model="weight" :mandatory="false">
              <v-radio color="secondary" label="kgs" value="kgs"></v-radio>
              <v-radio color="secondary" label="lbs" value="lbs"></v-radio>
            </v-radio-group>
            <v-divider></v-divider>
            <v-radio-group v-model="length" :mandatory="false">
              <v-radio color="secondary" label="cm" value="cm"></v-radio>
              <v-radio color="secondary" label="inches" value="inches"></v-radio>
            </v-radio-group>
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      app
    >
      <v-list class="pa-0">
          <v-list-tile avatar class="primary white--text" style="height: 64px;">
            <v-list-tile-avatar
              v-if="userProfile.name"
              class="headline font-weight-light white--text"
            >
            <img style="border-radius: none" src="@/assets/img/logo.png" alt="fresh start logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
            <v-list-tile-title> <h3>Leaner Living</h3> </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        <v-divider></v-divider>
      </v-list>
      <v-list class="pt-0" dense>
        <v-list-tile v-for="item in navigationItems" :key="item.title" @click="goTo(item.title)">
            <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.title === 'Manage Feedback'">
              <!-- <v-icon :color="item.active ? 'teal' : 'grey'">chat_bubble</v-icon> -->
              <v-chip v-if="notifications.length > 0" small color="secondary" text-color="white">
                {{notifications.length}} new
              </v-chip>
            </v-list-tile-action>
        </v-list-tile>
        <v-subheader>Tools</v-subheader>
        <v-list-tile v-for="item in drawerItems" :key="item.title" @click="goTo(item.title)">
            <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="openSettings">
            <v-list-tile-action>
            <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title>Personal Settings</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>

          <v-list-group
            prepend-icon="link"
            no-action
            id="share-group"
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Share Fresh Start Link</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              @click="copyToClipboard('fresh')"
            >
              <input type="hidden" id="fresh" :value="fresh">
              <v-list-tile-content>
                <v-list-tile-title>Fresh Starter</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-tooltip right>
                  <v-icon
                    slot="activator"
                  >file_copy</v-icon>
                  <span>copy url</span>
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              @click="copyToClipboard('personal')"
            >
              <input type="hidden" id="personal" :value="one2one">
              <v-list-tile-content>
                <v-list-tile-title>One-One Client</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-tooltip right>
                  <v-icon
                    slot="activator"
                  >file_copy</v-icon>
                  <span>copy url</span>
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              @click="copyToClipboard('trial')"
            >
              <input type="hidden" id="trial" :value="trial">
              <v-list-tile-content>
                <v-list-tile-title>Trial User</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-tooltip right>
                  <v-icon
                    slot="activator"
                  >file_copy</v-icon>
                  <span>copy url</span>
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        <v-divider inset></v-divider>
        <v-list-tile @click="logout">
          <v-list-tile-action>
          <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
          <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app color="primary" dark flat>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{$route.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon dark @click="$router.push({ name: 'Manage User', params: { userId: $route.params.userId }})">
        <v-icon>refresh</v-icon>
      </v-btn> -->
    </v-toolbar>

    <v-content >
      <v-container :class="{'no-padding': $route.meta.noPadding}" fluid fill-height align-start aligh-content-start>
        <slot />
      </v-container>
    </v-content>

    <!-- <v-bottom-nav :value="true" class="hidden-sm-and-up" :active.sync="e1" :app="isTouch" shift fixed color="primary">
      <v-btn v-for="item in navigationItems" :key="item.title" flat color="white" :value="item.title" @click="goTo(item.title)">
        <span>{{item.title}}</span>
        <v-icon>{{item.icon}}</v-icon>
      </v-btn>
    </v-bottom-nav> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { db, auth } from '@/services/firebase'

const freshUrl = 'https://freshstart.leaner-living.com/signUp?token=' + encodeURIComponent('fresh&c9739d6d774a4da1ae31ed90424bf13d')
const trialUrl = 'https://freshstart.leaner-living.com/signUp?token=' + encodeURIComponent('trial&c9739d6d774a4da1ae31ed90424bf13d')
const one2oneUrl = 'https://freshstart.leaner-living.com/signUp?token=' + encodeURIComponent('one2one&c9739d6d774a4da1ae31ed90424bf13d')

export default {
  name: 'app',
  data () {
    return {
      trial: trialUrl,
      fresh: freshUrl,
      one2one: one2oneUrl,
      e1: this.$route.name,
      drawer: null,
      drawerItems: [
        { value: 'exerciseTools', title: 'Exercise Tools', icon: 'fitness_center' }
      ],
      navigationItems: [
        { title: 'Dashboard', icon: 'home', admin: true },
        { title: 'Manage Workouts', icon: 'fitness_center', admin: true },
        { title: 'Manage Users', icon: 'supervisor_account', admin: true },
        { title: 'Manage Feedback', icon: 'question_answer', admin: true }
      ],
      weight: '',
      length: '',
      settingsDialog: false,
      notifications: []
    }
  },
  props: ['isTouch'],
  mounted () {
    this.getNotifications()
  },
  watch: {
    weight (val) {
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      localMeasureSystem.weight = this.weight
      localStorage.setItem('measureSystem', JSON.stringify(localMeasureSystem))
    },
    length (val) {
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      localMeasureSystem.length = this.length
      localStorage.setItem('measureSystem', JSON.stringify(localMeasureSystem))
    }
  },
  methods: {
    getNotifications: function () {
      var self = this
      db.collection('notifications').where('user_id', '==', self.currentUser).where('read_at', '==', null)
        .onSnapshot(function (querySnapshot) {
          querySnapshot.docChanges().forEach(function (change) {
            if (change.type === 'added') {
              var newItem = change.doc.data()
              self.$set(newItem, 'id', change.doc.id)
              self.notifications.push(newItem)
            }
            if (change.type === 'removed') {
              let i = self.notifications.map(item => item.id).indexOf(change.doc.id) // find index of your object
              self.notifications.splice(i, 1)
            }
          })
        })
    },
    openSettings: function () {
      if (!localStorage.getItem('measureSystem')) {
        var measureSystem = {
          length: 'cm', weight: 'kgs'
        }
        this.length = 'cm'
        this.weight = 'kgs'
        localStorage.setItem('measureSystem', JSON.stringify(measureSystem))
        this.settingsDialog = true
      } else {
        var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
        this.length = localMeasureSystem.length
        this.weight = localMeasureSystem.weight
        this.settingsDialog = true
      }
    },
    goTo: function (title) {
      if (this.isTouch) {
        this.drawer = false
      }
      setTimeout(() => this.$router.push({name: title}), 200)
    },
    logout () {
      var self = this
      auth.signOut()
        .then(function () {
          self.$store.dispatch('logout').then(
            self.$router.push('/login')
          )
        })
        .catch(function () {
          // An error happened
        })
    },
    copyToClipboard (id) {
      let testingCodeToCopy = document.querySelector('#' + id)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successfully' : 'unsuccessfully'
        alert('Link copied to clipboard ' + msg)
      } catch (err) {
        alert('Oops, unable to copy')
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    background () {
      return require('@/assets/header/' + this.$route.meta.image + '.jpg')
    },
    toolbarColor () {
      if (this.isTouch) {
        return 'white'
      } else {
        return 'primary'
      }
    }
  }
}
</script>

<style scoped >
 header {
  padding: 0px;
  overflow: hidden;
 }
 .v-avatar img {
  border-radius: 0px!important;
 }
 #share-group .v-list__tile--link .v-tooltip .v-icon {
  color: #fff;
 }
 #share-group .v-list__tile--link:hover .v-tooltip .v-icon {
  color: rgba(0,0,0,.54);
 }
 .v-content {
   overflow-x: hidden
 }
</style>



// WEBPACK FOOTER //
// src/components/layouts/admin.vue